import { render, staticRenderFns } from "./FormRaporttiAsetuksetReskontraRaportti.vue?vue&type=template&id=2fa905cc&"
import script from "./FormRaporttiAsetuksetReskontraRaportti.vue?vue&type=script&lang=js&"
export * from "./FormRaporttiAsetuksetReskontraRaportti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa905cc')) {
      api.createRecord('2fa905cc', component.options)
    } else {
      api.reload('2fa905cc', component.options)
    }
    module.hot.accept("./FormRaporttiAsetuksetReskontraRaportti.vue?vue&type=template&id=2fa905cc&", function () {
      api.rerender('2fa905cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormRaporttiAsetuksetReskontraRaportti.vue"
export default component.exports